import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/reset-setting',
    name: 'reset-settings',
    component: () => import('../views/Settings/ResetPreferences.vue'),
    meta: {
      requiresAuth: true,
      title: '設定のリセット'
    }
  }
]

export default routes
